import { PrimaryButton } from "@fluentui/react/lib/Button"
import { Dialog, DialogFooter, DialogType } from "@fluentui/react/lib/Dialog"
import { IProcessedStyleSet } from "@fluentui/react/lib/Styling"
import { classNamesFunction, styled } from "@fluentui/react/lib/Utilities"
import React from "react"

import { MessageBoxStyles } from "./MessageBox.styles"
import { IMessageBoxStyles, MessageBoxProps } from "./MessageBox.types"

/**
 * The MessageBox component renders a dialog for messages or errors.
 *
 * Links:
 * - [Checkout the code](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/MessageBox/MessageBox.tsx)
 * - [MessageBoxStyles](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/MessageBox/MessageBox.styles.ts)
 * - [MessageBoxProps](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/MessageBox/MessageBox.types.ts)
 * - [MS Fluent Dialog](https://developer.microsoft.com/de-DE/fluentui#/controls/web/dialog)
 *
 * @visibleName MessageBox
 */
export function IMessageBox(props: MessageBoxProps) {
    const { styles, theme } = props
    const classNames = classNamesFunction()(
        styles,
        theme
    ) as IProcessedStyleSet<IMessageBoxStyles>

    const dialogContentProps = {
        type: DialogType.normal,
        title: props.title,
        closeButtonAriaLabel: "Close"
    }

    return (
        <Dialog
            className={classNames.root}
            hidden={false}
            dialogContentProps={dialogContentProps}
            modalProps={{
                className: classNames.modal,
                ...props.modalProps
            }}
        >
            {props.message}
            <DialogFooter className={classNames.footer}>
                <PrimaryButton
                    onClick={() => props.onClick && props.onClick()}
                    text="OK"
                    className={classNames.button}
                />
            </DialogFooter>
        </Dialog>
    )
}

export const MessageBox = styled(IMessageBox, MessageBoxStyles)
